import React, { FC } from "react";

import SecurityTopic from "@/pages/SecurityAwareness/components/SecurityTopic";
import { phishingQuiz, phishingSlides } from "@/constants/phishing";
import { ITopic, SecurityTopicEnum } from "@/pages/SecurityAwareness/types";

const Phishing: FC<ITopic> = ({
  handleNextTopic,
  isPassed,
  setTestResults,
}) => {
  return (
    <SecurityTopic
      slides={phishingSlides}
      quizName={SecurityTopicEnum.Phishing}
      quizList={phishingQuiz}
      handleNextTopic={handleNextTopic}
      isPassed={isPassed}
      setTestResults={setTestResults}
    />
  );
};

export default Phishing;
